import { render, staticRenderFns } from "./MyMoveFile.vue?vue&type=template&id=16121e8a"
import script from "./MyMoveFile.vue?vue&type=script&lang=js"
export * from "./MyMoveFile.vue?vue&type=script&lang=js"
import style0 from "./MyMoveFile.vue?vue&type=style&index=0&id=16121e8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports